import MIME_TYPES from '@bhb-frontend/utils/lib/mime-types';

/** 可透明图片 */
export const TRANSPARENT_PICTURE = [
  MIME_TYPES.png,
  MIME_TYPES.webp,
  MIME_TYPES.gif,
];
